import { createRegistry } from '../registry.js';
/**
 * The grid the captured cards sit on (`specs/M10-D1-dashboards.md` §2.1): 12 columns, a 56 px row
 * and a 16 px margin, so `height(rows) = 72·rows − 16` — which is exactly the 416 / 560 / 632 px
 * cards measured on production.
 */
export const WIDGET_GRID = {
    columns: 12,
    rowHeight: 56,
    margin: 16,
};
export function widgetPixelHeight(rows) {
    return rows * (WIDGET_GRID.rowHeight + WIDGET_GRID.margin) - WIDGET_GRID.margin;
}
export const widgetRegistry = createRegistry('widget-registry', (definition) => definition.id);
export function defineWidget(definition) {
    return definition;
}
export function registerWidget(definition) {
    widgetRegistry.register(definition);
    return definition;
}
//# sourceMappingURL=types.js.map